import React from "react";
import { Routes, Route } from "react-router-dom";
import { RequiredAdmin } from "./utils";

// Lazy load all admin components
const AdminPage = React.lazy(() => import("../components/admin/AdminPage"));
const AdminRubricsPage = React.lazy(
  () => import("../components/admin/AdminRubricsPage"),
);
const AdminModelsPage = React.lazy(
  () => import("../components/admin/AdminModelsPage"),
);
const AdminOrganizationPage = React.lazy(
  () => import("../components/admin/AdminOrganizationPage"),
);
const OrgAdminManagePage = React.lazy(
  () => import("../components/admin/OrgAdminManagePage"),
);
const AiPromptTemplateListPage = React.lazy(
  () => import("../components/admin/AiPromptTemplateListPage"),
);
const RubricPage = React.lazy(() => import("../components/admin/RubricPage"));
const AiPromptTemplateEditPage = React.lazy(
  () => import("../components/admin/AiPromptTemplateEditPage"),
);
const RubricEditPage = React.lazy(
  () => import("../components/admin/RubricEditPage"),
);
const AiLargeLanguageModelEditPage = React.lazy(
  () => import("../components/admin/AiLargeLanguageModelEditPage"),
);
const AdminResourcesPage = React.lazy(
  () => import("../components/admin/resource/AdminResourcePage"),
);
const ResourceUploadPage = React.lazy(
  () => import("../components/admin/resource/ResourceUploadPage"),
);
const ResourceEditPage = React.lazy(
  () => import("../components/admin/resource/ResourceEditPage"),
);
const UrlResourceUploadPage = React.lazy(
  () => import("../components/admin/resource/UrlResourceUploadPage"),
);

export const AdminRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RequiredAdmin>
          <AdminPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/rubrics"
      element={
        <RequiredAdmin>
          <AdminRubricsPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/models"
      element={
        <RequiredAdmin>
          <AdminModelsPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/organization"
      element={
        <RequiredAdmin>
          <AdminOrganizationPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/organization/:orgId/manage-admin"
      element={
        <RequiredAdmin>
          <OrgAdminManagePage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/template"
      element={
        <RequiredAdmin>
          <AiPromptTemplateListPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/rubric"
      element={
        <RequiredAdmin>
          <RubricPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/resource"
      element={
        <RequiredAdmin>
          <AdminResourcesPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/resource/:resouceId/create/edit"
      element={
        <RequiredAdmin>
          <ResourceUploadPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/resource/url/:resouceId/create/edit"
      element={
        <RequiredAdmin>
          <UrlResourceUploadPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/resource/:resouceUuid/update/edit"
      element={
        <RequiredAdmin>
          <ResourceEditPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/template/:templateId/:action/edit"
      element={
        <RequiredAdmin>
          <AiPromptTemplateEditPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/rubric/:rubricId/:action/edit"
      element={
        <RequiredAdmin>
          <RubricEditPage />
        </RequiredAdmin>
      }
    />
    <Route
      path="/llm/:llmId/:action/edit"
      element={
        <RequiredAdmin>
          <AiLargeLanguageModelEditPage />
        </RequiredAdmin>
      }
    />
  </Routes>
);
